export default "__VITE_ASSET__Bwhep8DZ__"